import t from "./highrise1320.mjs";
import e from "./highrise1418.mjs";
var s = "[object Arguments]";
function m(r) {
  return e(r) && t(r) == s;
}
export {
  m as default
};
